// hooks/useSeoWithParam.js
import { useEffect, useState } from "react";

const useSeoWithParam = (fetchSeoFunction, param) => {
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const fetchSeo = async () => {
      try {
        const response = await fetchSeoFunction(param);
        if (response && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("SEO fetch failed:", error);
      }
    };

    if (param) {
      fetchSeo();
    }
  }, [fetchSeoFunction, param]);

  return seoData;
};

export default useSeoWithParam;